import ProductCardSkeleton from "@components/ProductCard/ProductCardSkeleton";

import ProductListHeader from "./ProductListHeader";

const ProductListCarouselSkeleton = () => {
  return (
    <section>
      <ProductListHeader>
        <div className="mb-2 h-4 w-24 animate-pulse bg-gray-100" />
        <div className="mb-2 h-4 w-24 animate-pulse bg-gray-100" />
      </ProductListHeader>
      <div className="flex flex-nowrap overflow-hidden">
        <ProductCardSkeleton />
        <ProductCardSkeleton />
        <ProductCardSkeleton />
        <ProductCardSkeleton />
        <ProductCardSkeleton />
        <ProductCardSkeleton />
        <ProductCardSkeleton />
        <ProductCardSkeleton />
      </div>
    </section>
  );
};

ProductListCarouselSkeleton.displayName = "ProductListCarouselSkeleton";

export default ProductListCarouselSkeleton;
